import React, { useEffect, useMemo, useRef, useState } from 'react'
import styles from '../styles/vipWithdrawalLimit.module.scss'
import VipLists from './vipLists'
import { useTranslation } from 'react-i18next'
import { useVipCfgList, useVipWeekInfo } from '../hooks/useVip'


const VipWithdrawalLimit = ({gradeData}) => {gradeData
  const { t } = useTranslation('vip')

  const { memberGradeConfigList: ConfigList, memberInfoChangeList: changeList } = gradeData || {}
  const dataList = useMemo(() => {
    return [
      {
        title: t('vipWithdrawalLimit.dailyWithdrawals')
      },
      {
        title: t('vipWithdrawalLimit.dailyWithdrawalLimit')
      }
    ]
  }, [])
  
  return (
    <div className={styles.vipWithdrawalLimit}>
      <div className={styles.upgrade_title}>
        <div>VIP withdrawal limit</div>
        <div>{t('vipWithdrawalLimit.vipWithdrawalLimit')}</div>
      </div>

      <VipLists 
        list={dataList}
        onTitle = {function (v:any,index3:number){
          return <div key={index3}>{v.title}</div>;
        }}
        onValue={function (e: any, x: any, index1, index2) {
          return <div key={index2}>{ConfigList?.[index1]?.[
            index2 === 0 ? 'dayWithdrawalCounts' : 'dayWithdrawalMoney'
        ]}</div>;
        }}
      />
    </div>
    )
  }
export default VipWithdrawalLimit
